import { render } from "./PurchasePriceChangesDetail.vue?vue&type=template&id=78139dd0"
import script from "./PurchasePriceChangesDetail.vue?vue&type=script&lang=js"
export * from "./PurchasePriceChangesDetail.vue?vue&type=script&lang=js"

import "./PurchasePriceChangesDetail.vue?vue&type=style&index=0&id=78139dd0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__